import { minLength, prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class WorkerBankAccount extends Resource {
    public override type = 'workerBankAccounts';

    @prop()
    @required()
    public bankId: string = '';

    @prop()
    @required()
    @minLength({ value: 24 })
    public accountNumber: string = '';

    @prop()
    @required()
    @minLength({ value: 8 })
    public swift: string = '';

}